import {
  GET_PRESCRIPTORS
} from '../mutation-types'

const state = {
  all: []
}

const mutations = {
  [GET_PRESCRIPTORS] (state, data) {
    // state.all = data
    state.all = data.sort(function (a, b) {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    })
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/prescriptors.js